import { render, staticRenderFns } from "./MenuMusicTherapy.vue?vue&type=template&id=700b53dc&"
import script from "./MenuMusicTherapy.vue?vue&type=script&lang=js&"
export * from "./MenuMusicTherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports